import { getApi } from '../../components/Shared/shared';
const baseURL = getApi();

export const supplierUrls = {
  suppliers: `${baseURL}/suppliers`
};

export default supplierUrls;
